module.exports = __webpack_public_path__ + "img/10.3b0de8d1.jpg";